import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

interface OrderItemCancellationData {
  orderItemId: number;
  cancellationReasons: Array<{ title: string; code: string }>;
}

@Component({
  selector: 'order-cancellation-confirmation-card',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatFormFieldModule,
  ],
  templateUrl: './order-cancellation-confirmation-card.component.html',
  styleUrl: './order-cancellation-confirmation-card.component.scss',
})
export class OrderCancellationConfirmationCardComponent {
  cancellationForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: OrderItemCancellationData,
  ) {}

  ngOnInit(): void {
    this.cancellationForm = this.formBuilder.group({
      orderItemId: this.data.orderItemId,
      reason: ['', Validators.required],
      comment: [''],
    });
  }
}
